import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import styled from 'styled-components';
import { BATTLESHIP, EERIE } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Loadable from 'UIComponents/decorators/Loadable';
import { updateArticle } from '../../../actions/article/UpdateArticleActions';
import sanitizeArticleHtml from '../../../utils/sanitizeArticleHtml';
import { isBodyValid } from '../../../utils/tinymceUtils';
import memoizeOne from 'react-utils/memoizeOne';
import CommandCoachingTips from 'content-assistance-lib/buttons/CommandCoachingTips';
import { getCanUseAIGeneratedContent } from '../../../selectors/contentAssistant';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FieldLabel = styled.span.withConfig({
  displayName: "BodyEditor__FieldLabel",
  componentId: "aps4ou-0"
})(["opacity:", ";transition:opacity 0.2s;font-weight:400;font-size:14px;color:", ";"], props => props.hidden ? 0 : 1, EERIE);
const Container = styled.div.withConfig({
  displayName: "BodyEditor__Container",
  componentId: "aps4ou-1"
})([".mce-content-readonly{color:", ";cursor:not-allowed;}"], BATTLESHIP);
const importTinyMCE = () => import( /* webpackChunkName:"KbTinyMCE" */'./KbTinyMCE').then(m => m.default);
const I18nKey = key => `knowledgeContentUI.edit.fields.articleBody.${key}`;
class BodyEditor extends Component {
  constructor(props) {
    super(props);
    this.handleBlur = event => {
      if (typeof this.props.onBlur === 'function') {
        this.props.onBlur(event);
      }
    };
    this.handleChange = (event, editor) => {
      this.updateArticleBodyAndLabel(editor);
    };
    this.handleFocus = event => {
      if (typeof this.props.onFocus === 'function') {
        this.props.onFocus(event);
      }
    };
    this.handleKeyUp = (event, editor) => {
      this.updateArticleBodyAndLabel(editor);
    };
    this.getLoadableTinyMCE = memoizeOne(initialContent => Loadable({
      delay: 0,
      loader: importTinyMCE,
      LoadingComponent: () => /*#__PURE__*/_jsx("div", {
        style: {
          position: 'relative',
          cursor: 'wait'
        },
        children: /*#__PURE__*/_jsx("div", {
          className: "article-body",
          dangerouslySetInnerHTML: {
            __html: sanitizeArticleHtml(initialContent)
          }
        })
      })
    }));
    this.state = {
      initialContent: props.article.values.hs_body,
      showLabel: !isBodyValid(props.article.values.hs_body)
    };
  }
  updateArticleBodyAndLabel(editor) {
    const bodyContent = editor.getContent();
    this.props.updateArticle(this.props.article, {
      values: {
        hs_body: bodyContent
      }
    });
    const shouldShowLabel = !isBodyValid(bodyContent);
    if (shouldShowLabel !== this.state.showLabel) {
      this.setState({
        showLabel: shouldShowLabel
      });
    }
  }
  render() {
    const {
      className,
      gates,
      readOnly,
      scopes,
      canUseAIGeneratedContent
    } = this.props;
    const {
      initialContent,
      showLabel
    } = this.state;
    const TinyMceWrapper = this.getLoadableTinyMCE(initialContent);
    return /*#__PURE__*/_jsxs(Container, {
      className: "tinymce-body-container m-x-auto",
      children: [canUseAIGeneratedContent && /*#__PURE__*/_jsx(CommandCoachingTips, {
        attachTo: ".tinymce-body-container",
        placement: "top right"
      }), /*#__PURE__*/_jsxs(FieldLabel, {
        hidden: !showLabel,
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: I18nKey('label')
        }), " *"]
      }), /*#__PURE__*/_jsx(TinyMceWrapper, {
        className: className,
        gates: gates,
        scopes: scopes,
        initialContent: initialContent,
        onChange: this.handleChange,
        onKeyUp: this.handleKeyUp,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        readOnly: readOnly
      })]
    });
  }
}
BodyEditor.propTypes = {
  canUseAIGeneratedContent: PropTypes.bool.isRequired,
  className: PropTypes.string,
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof List' is not assignable t... Remove this comment to see the full error message
  gates: PropTypes.instanceOf(Immutable.List).isRequired,
  onBlur: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof List' is not assignable t... Remove this comment to see the full error message
  scopes: PropTypes.instanceOf(Immutable.List).isRequired,
  updateArticle: PropTypes.func.isRequired
};
const mapStateToProps = state => {
  const {
    articleContentInfo: {
      article
    },
    auth: {
      gates,
      scopes
    }
  } = state;
  return {
    article,
    gates,
    scopes,
    canUseAIGeneratedContent: getCanUseAIGeneratedContent(state)
  };
};
const mapDispatchToProps = {
  updateArticle
};
export default connect(mapStateToProps, mapDispatchToProps)(BodyEditor);